<template functional>
  <ul :class="[
    'list-unstyled standard-gov-links small mb-0 d-flex flex-column flex-sm-row',
    'flex-wrap gap-1 gap-sm-2 justify-content-center',
    data.class,
    data.staticClass
  ]">
    <li>
      <a href="https://www.hrsa.gov/about/508-resources.html" title="Government links to helpful resources and sites">Accessibility</a>
    </li>
    <li>
      <a href="https://www.hhs.gov/web/policies-and-standards/hhs-web-policies/disclaimer/index.html">Disclaimers</a>
    </li>
    <li>
      <a href="https://www.hrsa.gov/foia/index.html">Freedom of Information Act</a>
    </li>
    <li>
      <a href="https://www.hhs.gov">Health and Human Services</a>
    </li>
    <li>
      <a href="https://www.hrsa.gov/eeo/no-fear-act/lawsandprotections">No FEAR Act</a>
    </li>
    <li>
      <a href="https://www.hhs.gov/web/policies-and-standards/hhs-web-policies/privacy/index.html">Privacy Policy</a>
    </li>
    <li>
      <a href="https://www.usa.gov/">USA.gov</a>
    </li>
    <li>
      <a href="https://www.hhs.gov/web/policies-and-standards/hhs-web-policies/plugins/index.html">Viewers &amp; Players</a>
    </li>
    <li>
      <a href="https://www.hhs.gov/vulnerability-disclosure-policy/index.html">Vulnerability Disclosure Policy</a>
    </li>
    <li>
      <a href="https://www.whitehouse.gov/">WhiteHouse.gov</a>
    </li>
  </ul>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/mixins";

.standard-gov-links {
  column-gap: 0 !important;

  @include media-breakpoint-up(sm) {
    li:not(:last-child):after {
      content: "";
      border-left: 1px solid $link-color;
      margin-left: 0.5em;
      margin-right: 0.5em;
    }
  }

  a:not(:hover) { text-decoration: none; }
}
</style>
